import { dictionaryApi } from './dictionaryClient';

export type AmarkoshWordScalars = {
  word: string;
  linga: string;
  artha: string;
  amarkoshId: number;
};

export type AmarkoshWord = AmarkoshWordScalars & {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
};

export type CreateAmarkoshWordBody = AmarkoshWordScalars;

function normalizeList(data: unknown): AmarkoshWord[] {
  if (Array.isArray(data)) return data as AmarkoshWord[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: AmarkoshWord[] }).data;
  }
  return [];
}

export async function listAmarkoshWords(): Promise<AmarkoshWord[]> {
  const res = await dictionaryApi.get<unknown>('/amarkosh-word');
  return normalizeList(res.data);
}

export async function getAmarkoshWord(id: number): Promise<AmarkoshWord> {
  const res = await dictionaryApi.get<AmarkoshWord>(`/amarkosh-word/${id}`);
  return res.data;
}

export async function createAmarkoshWord(body: CreateAmarkoshWordBody): Promise<AmarkoshWord> {
  const res = await dictionaryApi.post<AmarkoshWord>('/amarkosh-word', body);
  return res.data;
}

export async function updateAmarkoshWord(
  id: number,
  body: Partial<AmarkoshWordScalars>
): Promise<AmarkoshWord> {
  const res = await dictionaryApi.patch<AmarkoshWord>(`/amarkosh-word/${id}`, body);
  return res.data;
}

export async function deleteAmarkoshWord(id: number): Promise<void> {
  await dictionaryApi.delete(`/amarkosh-word/${id}`);
}
